
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card>

      <vs-prompt
        title= "Calculer commission"
        accept-text= "Générer"
        cancel-text = "Annuler"
        :active.sync="calculePrompt"
        :buttons-hidden="true"
        @close="closeCalculePrompt"
      >
        <div class="con-exemple-prompt">
          <table class="w-full">
            <tr>
              <th class="w-1/4">Date : </th>
              <td>
                <date-range-picker
                  ref="picker"
                  :locale-data="{ direction: 'ltr',
                                  format: 'mm/dd/yyyy',
                                  separator: ' - ',
                                  applyLabel: 'Valider',
                                  cancelLabel: 'Annuler',
                                  weekLabel: 'W',
                                  customRangeLabel: 'Custom Range',
                                  daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                                  monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                                  firstDay: 0
                                }"
                  v-model="commission.dateRange"
                  class="w-full mr-1"
                  :ranges="{
                    'Today': [today, new Date(today.getFullYear(), today.getMonth(), today.getDate(), 11, 59, 59, 999)],
                    'Yesterday': [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 11, 59, 59, 999)],
                    'This month': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999)],
                    'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1),new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)],
                    'This year': [new Date(today.getFullYear(), 0, 1),new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)],
                    'Last year': [new Date(today.getFullYear() - 1, 0, 1),new Date(today.getFullYear() - 1, 11, 31, 11, 59, 59, 999)]
                  }"
                >
                    <template v-slot:input="picker" style="min-width: 350px;">
                    <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" />
                        {{ picker.startDate | moment("DD-MMMM-YYYY") }} - {{ picker.endDate | moment("DD-MMMM-YYYY") }}
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />

                    </template>

                    <!--    ranges (new slot syntax) -->
                    <template #ranges="ranges">
                      <div class="ranges">
                        <ul>
                          <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                            <b v-if="name == 'Today'">Aujourd'hui</b>
                            <b v-if="name == 'Yesterday'"> Hier</b>
                            <b v-if="name == 'This month'"> Ce mois</b>
                            <b v-if="name == 'This year'"> Cette année</b>
                            <b v-if="name == 'Last month'">Mois dérnier</b>
                            <b v-if="name == 'Last year'">Année dérnière</b>
                          </li>
                        </ul>
                      </div>
                    </template>
                </date-range-picker>
              </td>
            </tr>
            <tr>
              <th class="w-1/4">Artisan : </th>
              <td>
                <v-select class="w-full mr-1" :clearable="true" label="full_name" v-model="commission.artisan_id" :options="Artisan_choices" :reduce="artisan => artisan.id" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-center font-bold">
                Commission <br> {{ commission.ht }} €
              </td>
            </tr>
          </table>
        </div>
      </vs-prompt>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-breadcrumb>
            <li><router-link to="/">Dashboard</router-link><span class="vs-breadcrum--separator">/</span></li>
            <li aria-current="page" class="active">Auto-Factures</li>
          </vs-breadcrumb>
        </div>
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-2 text-right">
          <vs-button type="line" line-origin="left" color="danger" class="mr-5"  @click="filterFildes()">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" v-if="!filter" /> <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4" v-if="filter" /> Filtrer
          </vs-button>
          <vs-button type="line" line-origin="left" color="success" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Ajouter auto-facture
          </vs-button>
          <vs-button type="line" line-origin="left" @click="calculePrompt = true">
            <feather-icon icon="DollarSignIcon" svgClasses="h-4 w-4" /> Calculer commission
          </vs-button>
        </div>
      </div>

      <div class="vx-row w-full mb-2" v-if="filter">
        <div class="vx-col md:w-1/6 w-full">
          <vs-input label="N°" v-model="f_num" class="mr-1 w-full" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
            <label for="" class="vs-input--label">Clients</label>
            <v-select multiple class="w-full" name="client_ids" :clearable="true" label="full_name" v-model="f_clients_id" :options="Client_choices" :reduce="client => client.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <div slot="no-options">Désolé, aucun client correspondante.</div>
            </v-select>
          </div>
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
            <label for="" class="vs-input--label">Filtrer par artisans</label>
            <v-select multiple class="w-full" name="artisan_ids" :clearable="true" label="full_name" v-model="f_artisans_id" :options="Artisan_choices" :reduce="artisan => artisan.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <div slot="no-options">Désolé, aucun artisan correspondante.</div>
            </v-select>
          </div>
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
            <label for="" class="vs-input--label" >Etat</label>
            <v-select name="etat" class="ml-1" :clearable="false" label="label" v-model="f_etat" :options="status_choices" :reduce="status => status.value" :dir="$vs.rtl ? 'rtl' : 'ltr'">
              <div slot="no-options">Désolé, aucune etat correspondante.</div>
            </v-select>
          </div>
        </div>

        <div class="vx-col md:w-1/3 w-full">
          <div class="flex flex-col vs-component vs-con-input-label vs-input w-full vs-input-primary ">
            <label for="" class="vs-input--label" >Date de création</label>
            <date-range-picker
              style="max-width: 350px;"
              class="mt-2"
              ref="picker"
              :locale-data="{ direction: 'ltr',
                              format: 'mm/dd/yyyy',
                              separator: ' - ',
                              applyLabel: 'Valider',
                              cancelLabel: 'Annuler',
                              weekLabel: 'W',
                              customRangeLabel: 'Custom Range',
                              daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                              monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                              firstDay: 0
                            }"
              v-model="dateRange"
              :ranges="{
                'Today': [today, new Date(today.getFullYear(), today.getMonth(), today.getDate(), 11, 59, 59, 999)],
                'Yesterday': [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 11, 59, 59, 999)],
                'This month': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999)],
                'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1),new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)],
                'This year': [new Date(today.getFullYear(), 0, 1),new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)],
                'Last year': [new Date(today.getFullYear() - 1, 0, 1),new Date(today.getFullYear() - 1, 11, 31, 11, 59, 59, 999)]
              }"
            >
                <template v-slot:input="picker" style="min-width: 350px;">
                <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" />
                    {{ picker.startDate | moment("DD-MMMM-YYYY") }} - {{ picker.endDate | moment("DD-MMMM-YYYY") }}
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />

                </template>

                <!--    ranges (new slot syntax) -->
                <template #ranges="ranges">
                  <div class="ranges">
                    <ul>
                      <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                        <b v-if="name == 'Today'">Aujourd'hui</b>
                        <b v-if="name == 'Yesterday'"> Hier</b>
                        <b v-if="name == 'This month'"> Ce mois</b>
                        <b v-if="name == 'This year'"> Cette année</b>
                        <b v-if="name == 'Last month'">Mois dérnier</b>
                        <b v-if="name == 'Last year'">Année dérnière</b>
                      </li>
                    </ul>
                  </div>
                </template>
            </date-range-picker>
          </div>

        </div>
      </div>

      <vs-table ref="table"  v-model="selected" pagination :max-items="itemsPerPage" :data="filteredItems" noDataText="Aucune facture trouvé">


        <template slot="thead">
          <vs-th>N°</vs-th>
          <vs-th>N° intervention</vs-th>
          <vs-th>Commission</vs-th>
          <vs-th>Client</vs-th>
          <vs-th>Artisans</vs-th>
          <vs-th>Date de création</vs-th>
          <vs-th>Fournitures</vs-th>
          <vs-th>Etat de facture</vs-th>
          <vs-th>Status</vs-th>
        </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td>
                  <p @click.stop="editData(tr.id)" class="num_object">{{ tr.num_auto_invoice }}</p>
                </vs-td>

                <vs-td>
                  <p>BI{{ tr.intervention.id | strPadStart('0') }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.commission }} €</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.client.company ? tr.client.company : (tr.client.firstname +' '+ tr.client.lastname) }}</p>
                </vs-td>

                 <vs-td>
                  <p>{{ tr.artisan.firstname +' '+ tr.artisan.lastname }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.date | date }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ sumFournitureByInvoice(tr.lines) }}</p>
                </vs-td>

                <vs-td>
                  <p v-if="tr.intervention.invoice">
                      <vs-chip v-if="tr.intervention.invoice.status == 'issued'" color="#ff9f43">Créé</vs-chip>
                      <vs-chip v-if="tr.intervention.invoice.status == 'sent'" color="#005cf6">Envoyé</vs-chip>
                      <vs-chip v-if="tr.intervention.invoice.status == 'paid'" color="#28c76f">Payé</vs-chip>
                      <vs-chip v-if="tr.intervention.invoice.status == 'partial'" color="#15daf0">Payé en partie</vs-chip>
                  </p>
                </vs-td>

                <vs-td>
                  <p>
                    <vs-dropdown vs-trigger-click>
                      <vs-chip v-if="tr.status == 'issued'" color="#ff9f43">Créé <i class="material-icons">arrow_drop_down</i></vs-chip>
                      <vs-chip v-if="tr.status == 'paid'" color="#28c76f">Payé <i class="material-icons">arrow_drop_down</i></vs-chip>

                      <vs-dropdown-menu >
                        <vs-dropdown-item @click="changeStatus(tr.id,tr.status,'issued')"> Créé </vs-dropdown-item>
                        <vs-dropdown-item @click="changeStatus(tr.id,tr.status,'paid')"> Payé </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
      </vs-table>

      <table>
        <tr>
          <td class="font-semibold">Totale HT :</td>
          <td class="pl-5">{{ commissions }} €</td>
        </tr>
        <tr>
          <td class="font-semibold">Totale fournitures</td>
          <td class="pl-5">{{ sumFournitures }}</td>
        </tr>
        <tr>
          <td class="font-semibold">Nbrs factures</td>
          <td class="pl-5">{{ nbrs }}</td>
        </tr>
      </table>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { mapGetters, mapActions } from "vuex"
import { moment } from 'vue-moment';
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


export default {
  components: {
    vSelect,
    flatPickr,
    moment,
    DateRangePicker
  },
  data() {
    let today = new Date()
    today.setHours(0, 0, 0, 0)

    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      sidebarData: {},
      showLoading: false,

      status_choices : [
        {value: null, label: 'Tous'},
        {value: 'issued', label: 'Créé'},
        {value: 'paid', label: 'Payé'}
      ],

      configFromdateTimePicker: {
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },

      filter : false,
      f_num: "",
      f_artisans_id: [],
      f_clients_id: [],
      f_etat: null,
      dateRange: {
        startDate: this.$moment().startOf('month').format('YYYY-MM-DD'),
        endDate: this.$moment().format('YYYY-MM-DD')
      },

      calculePrompt: false,
      commission: {
        artisan_id: null,
        dateRange: {
          startDate: this.$moment().startOf('month').format('YYYY-MM-DD'),
          endDate: this.$moment().format('YYYY-MM-DD')
        },
        ht: '0.00'
      },
      today: today
      
    }
  },
  computed: {
    ...mapGetters('autoInvoices', { 'data' : 'GET_ITEMS' }),
    ...mapGetters('artisans', {'Artisan_choices' : 'GET_ITEMS_FULL_NAME'}),
    ...mapGetters('clients', {'Client_choices' : 'GET_ITEMS_FULL_NAME'}),
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length
    },
    filteredItems() {
      let dataFilter = this.data

      dataFilter.map(invoice =>  {
        if(!invoice.artisan)
          console.log(invoice.artisan_id);
      })

      if(this.f_num != null && this.f_num != "") {
        dataFilter = dataFilter.filter(item => {
          
          return item.num_auto_invoice.toLowerCase().includes(this.f_num.toLowerCase())
        })
      }

      if(this.f_artisans_id != null && this.f_artisans_id.length > 0) {
        dataFilter = dataFilter.filter(item => {
          return item.artisan && this.f_artisans_id.includes(item.artisan.id)
        })
      }

      if(this.f_clients_id != null && this.f_clients_id.length > 0) {
        dataFilter = dataFilter.filter(item => {
          return this.f_clients_id.includes(item.client_id)
        })
      }

      if(this.f_etat != null) {
        dataFilter = dataFilter.filter(item => {
          return this.f_etat == item.status
        })
      }

      if(this.f_fromDate != null && this.f_toDate != null){
          dataFilter = dataFilter.filter(item => {
            return this.format_date(item.date) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date) <= this.format_date(this.dateRange.endDate)
          })
      }

      var search_object = {
        'num' : this.f_num,
        'artisans_id' : this.f_artisans_id,
        'clients_id' : this.f_clients_id,
        'etat' : this.f_etat,
        'fromDate' : this.dateRange.startDate,
        'toDate' : this.dateRange.endDate
      }

      localStorage.setItem("auto_factures_search", JSON.stringify(search_object))

       var search_objectk = JSON.parse(localStorage.getItem("auto_factures_search") || "[]")
      
      return dataFilter
    },
    commissions() {
      let num =  this.filteredItems.reduce((sum, i) => sum + i.commission, 0)
      return Math.round((num + Number.EPSILON) * 100) / 100
    },

    sumFournitures() {
      let sum = 0;
      this.filteredItems.map((invoice, index) => {
        let filterFournitures = invoice.lines.filter(item => {
          return item.redc == 0
        })
        if(filterFournitures.length > 0){
          sum = sum + filterFournitures.reduce((sum, i) => sum + i.cost, 0)
        } 
      })
      return Math.round((sum + Number.EPSILON) * 100) / 100;
    },

    nbrs() {
      return this.filteredItems.length
    }
  },
   watch: {
    showLoading (val) {
      if(val == true){
        this.$vs.loading({type: 'radius', color: '#be092f'})
      }else{
        this.$vs.loading.close()
      }
    },
    'commission.artisan_id'(val) {
      this.calcule(val)
    },
    'commission.dateRange'(val) {
      this.calcule(val)
    }

  },
  methods: {
    ...mapActions('autoInvoices', ['fetchItems','updateStatus']),
    ...mapActions('artisans', {'fetchArtisans':'fetchItemsFullName'}),
    ...mapActions('clients', {'fetchClients':'fetchItemsFullName'}),

    // editData(id) {
    //   this.$router.push(`/intervention/${id}`);
    // },

    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    filterFildes() {
      this.filter = !this.filter
      if(!this.filter) {
        this.f_num = ""
        this.f_artisans_id = []
        this.f_clients_id = []
        this.f_etat = null
        this.dateRange = {
          startDate: this.$moment().startOf('month').format('YYYY-MM-DD'),
          endDate: this.$moment().format('YYYY-MM-DD')
        },

        localStorage.removeItem("auto_factures_search");
      }
    },
    changeStatus(id, old_status, new_status) {
      if(old_status != new_status){
        this.updateStatus({id: id, status: new_status})
      }
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
    },
    addNewData() {
      this.$router.push('/auto-facture');
    },
    editData(id) {
      this.$router.push(`/auto-facture/${id}`);
    },
    calcule(val) {
      if(val) {
        var invoices =  this.data.filter(item => {
          return item.artisan && item.artisan.id == this.commission.artisan_id && new Date(item.date).setHours(0,0,0,0) >= new Date(this.commission.dateRange.startDate.setHours(0,0,0,0)) &&  new Date(item.date).setHours(0,0,0,0) <= new Date(this.commission.dateRange.endDate).setHours(0,0,0,0)
        })
        var num = invoices.reduce((sum, i) => sum + i.commission, 0)
        this.commission.ht = (Math.round((num + Number.EPSILON) * 100) / 100).toFixed(2)
      }else {
        this.commission.ht = '0.00'
      }
    },
    closeCalculePrompt() {
      this.commission.artisan_id = null
      this.commission.ht = '0.00'
    },
    sumFournitureByInvoice(lines) {
      let filterFournitures = lines.filter(item => {
        return item.redc == 0
      })
      let sumFourniture = "";
      if(filterFournitures.length > 0){
        sumFourniture = filterFournitures.reduce((sum, i) => sum + i.cost, 0)
      } 
      return sumFourniture;
    },
    format_date(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    },
  },
  created() {
    this.fetchItems()
    this.fetchArtisans()
    this.fetchClients()

    var search_object = JSON.parse(localStorage.getItem("auto_factures_search") || "[]")

    if(search_object && (search_object.num || search_object.artisans_id.length || search_object.clients_id.length || search_object.etat || search_object.fromDate || search_object.toDate)) {
      this.f_num = search_object.num
      this.f_artisans_id = search_object.artisans_id
      this.f_clients_id = search_object.clients_id
      this.f_etat = search_object.etat
      this.f_fromDate = search_object.fromDate
      this.f_toDate = search_object.toDate

      this.filter = true
    }
  },
  mounted() {
    this.isMounted = true;
  },
  filters:{
    strPadStart(value, pattern = "") {
      return value.toString().padStart(4,pattern)
    },
    date(value) {
      var [y, m, d] = value.split("-")
      return d+'/'+m+'/'+y
    }
  }
}
</script>

<style scoped>
  .num_object:hover{
    color: #be092f;
    text-shadow: -0.25px -0.25px 0 transparent, 0.25px 0.25px transparent;
  }

  .vuesax-app-is-ltr .con-vs-chip {
    width: 100%;
  }
  .vs-con-dropdown.parent-dropdown {
    width: 100%;
    cursor: pointer !important;
  }

</style>
